import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Stripe from "stripe";
import { post } from "../../api";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import { SIGN_IN } from "../../routes/routesConstant";
import { toast } from "react-toastify";
import logo from '../../assets/img/logo.png';

const PlanView = (props) => {
  const navigate = useNavigate();
  const [stripeSK, setStripeSK] = useState("");
  const [stripePK, setStripePK] = useState("");
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)
  const { web_base_url, cypher_token } = useSelector(
    (state) => state.initialApiReducer,
  );

  const redirectBaseUrl = () => {
    navigate('/');
  }

  //   const web_base_url = "http://localhost:9000/"; 

  // const { cypher_token } = useSelector(
  //   (state) => state.initialApiReducer,
  // );

  useEffect(() => {
    if (cypher_token) {
      let token = atob(cypher_token);
      token = token.split("-");
      setStripeSK(token[0]);
      setStripePK(token[1]);
    }
  }, [cypher_token]);

  const stripe = new Stripe(stripeSK);
  const { planData } = useSelector((state) => state.profileReducer);
  const { loginData } = useSelector((state) => state.authReducer);
  // const initiateTransaction = async () => {
  //   if (!loginData?.user_id) {
  //     navigate(`${SIGN_IN}`);
  //     return;
  //   }
  //   const obj = {
  //     user_id: loginData?.user_id || "",
  //     plan_id: planData?.[0]?.id || "",
  //     platform: 1 || "",
  //     pay_via: "STRIPE",
  //   };
  //   setIsLoadingBtn(true)
  //   const response = await post(
  //     `/initiate-payment?user_id=${obj.user_id}&plan_id=${obj.plan_id}&platform=${obj.platform}&pay_via=${obj.pay_via}`,
  //   );
  //   response.then((res) => {
  //     console.log("Promise then", res)
  //   })
  //   if (Array.isArray(response?.data) && response.data.length === 0) {
  //     toast(response.message);
  //     setIsLoadingBtn(false)
  //   }
  //   if (response?.data) {
  //     initPayment(response.data);
  //     setIsLoadingBtn(false)
  //   }
  // };

  const initiateTransaction = async () => {
  if (!loginData?.user_id) {
    navigate(`${SIGN_IN}`);
    return;
  }
  
  const obj = {
    user_id: loginData?.user_id || "",
    plan_id: planData?.[0]?.id || "",
    platform: 1 || "",
    pay_via: "STRIPE",
  };
  
  setIsLoadingBtn(true);
  
  try {
    const response = await post(
      `/initiate-payment?user_id=${obj.user_id}&plan_id=${obj.plan_id}&platform=${obj.platform}&pay_via=${obj.pay_via}`,
    );
    
    console.log("Response:", response);
    
    if (Array.isArray(response?.data) && response.data.length === 0) {
      toast(response.message);
      setIsLoadingBtn(false);
      // console.log("Array.isArray(response?.data) && response.data.length === 0")
      return;
    }
    
    if (response?.data) {
      initPayment(response.data);
    }
    
    
  } catch (error) {
    console.error("Error:", error);
    setIsLoadingBtn(false);
  }
};

  const initPayment = async (data) => {
    // console.log('Data', data); return false;
    const session = await stripe.checkout.sessions.create({
      customer_email: loginData?.email,
      line_items: [{ price: data?.price_id, quantity: 1 }],
      // line_items: [{ price: 'price_1RRe75PEX6ngEdtAyIITB8D2', quantity: 1 }],
      mode: "subscription",
      success_url: `${web_base_url}success?sid={CHECKOUT_SESSION_ID}&pti=${data?.pre_transaction_id}`,
      cancel_url: `${web_base_url}cancel?sid={CHECKOUT_SESSION_ID}&pti=${data?.pre_transaction_id}`,
    });
    setIsLoadingBtn(false);
    const stripeClient = await loadStripe(stripePK);
    stripeClient.redirectToCheckout({
      sessionId: session.id,
    });
  };

  return (
    <>
      <Header />
      {/* <div className="planpackage_page">
        <main className="planpackage_main">
          <section className="planepackage-section">
            <div className="container">
              <h2 className="title"> Subscription Plan</h2>
              <div className="row justify-content-center">
                <div className="col-lg-5 col-md-8  col-sm-12">
                  <div className="planepackage-panel">
                    <div className="pricetime-panel">
                      <div className="price-panel">
                        <span className="plan-price">
                          <sup className="price-unite"></sup>
                          <strong className="price_text">
                            ${planData?.[0]?.plan_price}
                          </strong>
                          <sub className="month">/Month</sub>
                        </span>
                      </div>
                    </div>
                    <div className="planepackage-contbody">
                      <ul>
                        <li>Ad-free streaming</li>
                        <li>Early Releases</li>
                        <li>Saved searches</li>
                        <li>Bonus features</li>
                        <li
                          className="plan-text"
                          dangerouslySetInnerHTML={{
                            __html: planData?.[0]?.plan_text || "",
                          }}
                        ></li>
                      </ul>
                      <button
                        type="button"
                        className="getstart-btn"
                        onClick={initiateTransaction}
                      >
                        Subscribe Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div> */}

      <div className="loginrgstr-page ChooseHowWatchPage">
        <div className="login_main">
          <section className='loginrgstrform-section'>
            <div className='loginrgstr-maincover'>
              <div className='container'>
                <div className='loginrgstr-main'>
                  <form>
                    <div className='subscrbwatchads-area'>
                      <div className="subscrbwatchads-headtop mb-8 text-center">
                        <div className="login-logo text-center">
                          <a href="/"> <img src={logo} alt="" /></a>
                        </div>
                        <p>Choose How You Want to Watch</p>
                      </div>

                      <div className="subscrbwatchads-grid">
                        <div className="subscrbwatchads-gridcard subscr-panel">
                          <h3>Subscribe</h3>
                          <div className="planepackage-panel---">
                            <div className="planepackage-contbody--">
                              <ul>
                                <li>Ad-free streaming</li>
                                <li>Early Releases</li>
                                <li>Saved searches</li>
                                <li>Bonus features</li>
                                <li
                                  className="cmsText"
                                  dangerouslySetInnerHTML={{
                                    __html: planData?.[0]?.plan_text || "",
                                  }}
                                ></li>
                              </ul>
                              {/* <button
                                type="button"
                                className="subscrbwatchads-btn"
                                onClick={initiateTransaction}
                              >
                                Subscribe Now
                              </button> */}
                              <button
                                type="button"
                                className="subscrbwatchads-btn"
                                onClick={initiateTransaction}
                                disabled={isLoadingBtn}
                              >
                                {isLoadingBtn ? (
                                  <>
                                   <span className="d-flex align-items-center gap-2">
                                     <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                   <span> &nbsp;Processing...</span>
                                   </span>
                                  </>
                                ) : (
                                  "Subscribe Now"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="subscrbwatchads-gridcard watchads-panel">
                          <h3>Watch with Ads</h3>
                          <p>Skip subscription and enjoy content with short ad breaks.</p>
                          <ul>
                            <li>Watch with ads</li>
                            <li>No early releases access</li>
                            <li>Bonus features</li>
                          </ul>
                          <button className="subscrbwatchads-btn" onClick={redirectBaseUrl}>
                            Continue with Ads
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
          {/* <LoginFooter /> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PlanView;
